import {
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { TanStackQueryIds } from '../query-ids'
import type { ElemetalInfosData, ElemetalInfosQuery } from '~~/src/api/elementals'
import { getElementalInfos } from '~~/src/api/elementals'

export const useGetElementalInfosQuery = (
  args: {
    id: MaybeRef<string | undefined>
    query?: MaybeRef<ElemetalInfosQuery>
  },
  options?: {
    enabled?: MaybeRef<boolean>
  },
): UseQueryReturnType<ElemetalInfosData, Error> => {
  return useQuery({
    queryKey: [TanStackQueryIds.ELEMENTAL_INFOS, args.id, args.query] as const,
    queryFn: async ({ queryKey }) => {
      const [_, id, query] = queryKey
      if (!id)
        return null
      const data = await getElementalInfos(id, query)
      return data
    },
    enabled: options?.enabled,
    ...options,
  })
}
